"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === "function" &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? "symbol"
        : typeof obj;
    };
  }
  return _typeof(obj);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: { value: subClass, writable: true, configurable: true }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
  return _setPrototypeOf(o, p);
}

function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== "undefined" &&
    right[Symbol.hasInstance]
  ) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var data = {
  config: {
    min: 0,
    max: 100,
    speed: 100,
    increment: 1,
    delay: 0
  },
  attributes: {
    min: "data-counter-min",
    max: "data-counter-max",
    speed: "data-counter-speed",
    increment: "data-counter-increment",
    delay: "data-counter-delay"
  }
};

var Screen =
  /*#__PURE__*/
  (function() {
    function Screen() {
      _classCallCheck(this, Screen);
    }

    _createClass(Screen, [
      {
        key: "render",
        value: function render(value) {
          this.element.innerHTML = value;
        }
      }
    ]);

    return Screen;
  })();

var Counter =
  /*#__PURE__*/
  (function(_Screen) {
    _inherits(Counter, _Screen);

    function Counter(selector, min, max, speed, increment, delay) {
      var _this;

      _classCallCheck(this, Counter);

      (_this = _possibleConstructorReturn(
        this,
        _getPrototypeOf(Counter).call(this)
      )),
        (_this.selector = selector),
        (_this.element = document.querySelector(_this.selector)),
        (_this.min =
          parseInt(_this.element.getAttribute(data.attributes.min)) ||
          data.config.min),
        (_this.max =
          parseInt(_this.element.getAttribute(data.attributes.max)) ||
          data.config.max),
        (_this.speed =
          parseInt(_this.element.getAttribute(data.attributes.speed)) ||
          data.config.speed),
        (_this.increment =
          parseInt(_this.element.getAttribute(data.attributes.increment)) ||
          data.config.increment),
        (_this.delay =
          parseInt(_this.element.getAttribute(data.attributes.delay)) ||
          data.config.delay),
        (_this.current = _this.min),
        _this.interval,
        _this.initialize();
      return _this;
    }

    _createClass(Counter, [
      {
        key: "die",
        value: function die() {
          clearTimeout(this.interval);
        }
      },
      {
        key: "count",
        value: function count() {
          this.current < this.max
            ? ((this.current += this.increment), this.render(this.current))
            : this.current > this.max && (this.render(this.max), this.die());
        }
      },
      {
        key: "initialize",
        value: function initialize() {
          var _this2 = this;

          this.delay > 0
            ? setTimeout(function() {
                _this2.interval = setInterval(
                  _this2.count.bind(_this2),
                  _this2.speed
                );
              }, this.delay)
            : (this.interval = setInterval(this.count.bind(this), this.speed)),
            this.render(this.min);
        }
      }
    ]);

    return Counter;
  })(Screen);
